// Predefined colour schemes for the theme picker. Each just needs a primary
// (and optional secondary) - MUI's createTheme derives .light/.dark/.contrastText
// automatically, and Topbar/Sidebar read those derived shades rather than
// hardcoding their own, so adding a scheme here is enough to reskin the app.
//
// `light` is an optional override for that auto-derived shade (used for the
// Topbar background) - only needed where the auto-derived tint doesn't match
// a colour that already has an established look, like the original pale
// lavender Topbar the app shipped with.
export const COLOR_THEMES = [
  { id: 'indigo', name: 'Brandon Auto Parts', primary: '#3f51b5', secondary: '#7986cb', light: '#c5cae9' },
  { id: 'ocean', name: 'Ocean Blue', primary: '#0277bd', secondary: '#00acc1' },
  { id: 'forest', name: 'Forest Green', primary: '#2e7d32', secondary: '#689f38' },
  { id: 'sunset', name: 'Sunset Orange', primary: '#e65100', secondary: '#f9a825' },
  { id: 'slate', name: 'Slate', primary: '#37474f', secondary: '#607d8b' },
];

export const DEFAULT_THEME_ID = COLOR_THEMES[0].id;

export const getColorTheme = (themeId) =>
  COLOR_THEMES.find((t) => t.id === themeId) || COLOR_THEMES[0];
